import { render, staticRenderFns } from "./Contabilidad.vue?vue&type=template&id=9bc64fe0"
import script from "./Contabilidad.vue?vue&type=script&lang=ts"
export * from "./Contabilidad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports